module.exports = __webpack_public_path__ + "static/media/food_no_img.0d756a89.jpg";